<div class="file-upload-list" [ngClass]="wrapperClasses">
  <ng-container *ngFor="let data of uploadedFiles">
    <div class="file-upload-summary" [ngClass]="getFileStatus(data)">
      <div class="file-upload-details-wrapper">
        <div class="file-upload-details">
          <ng-container *ngIf="!isStatusInProgress(data.status)">
            <div [class]="getFileStatusClass(data.status!)">
              <i></i>
            </div>
          </ng-container>
          <div class="labels">
            <p class="file-title">{{ getDesktopDisplayName(data.file) }}</p>
            <p class="file-title mobile">{{ getMobileDisplayName(data.file) }}</p>
            <p class="file-size" *ngIf="shouldDisplayFileSize(data)">{{ getReadableFileSize(data.file.size) }}</p>
            <div class="file-statuses mobile" *ngIf="!shouldDisplayFileSize(data)">
              <ng-container [ngTemplateOutlet]="fileStatus"></ng-container>
            </div>
          </div>
        </div>
        <ng-container *ngIf="isUploadProgressDisplayed(data)">
          <div class="upload-progress">
            <div class="progress-bar" [style.width]="data.progress + '%'"></div>
          </div>
          <div class="upload-progress loading-wheel">
            <kmd-loading-wheel></kmd-loading-wheel>
          </div>
        </ng-container>
        <div class="file-upload-controls">
          <div class="file-statuses"><ng-container [ngTemplateOutlet]="fileStatus"></ng-container></div>
          <div class="file-statuses mobile" *ngIf="shouldDisplayFileSize(data)"><ng-container [ngTemplateOutlet]="fileStatus"></ng-container></div>
          <div class="pause upload-control" (click)="pauseFileUpload(data)"
               *ngIf="data.status === uploadStatus.IN_PROGRESS">
            <i></i>
          </div>
          <div class="restart upload-control" (click)="retryFileUpload(data)" *ngIf="isRetryButtonDisplayed(data)">
            <i></i>
          </div>
          <div class="cancel upload-control" (click)="removeFile(data)">
            <i></i>
          </div>
        </div>
      </div>
    </div>
    <ng-template #fileStatus>
      <div class="file-status success completed" *ngIf="data.status === uploadStatus.COMPLETED">
        <label>Uploaded</label>
      </div>
      <div class="file-status error upload-error" *ngIf="data.status === uploadStatus.ERROR">
        <label>Upload error</label>
      </div>
      <div class="file-status error password-protected" *ngIf="data.status === uploadStatus.PASSWORD_PROTECTED">
        <label>Password protected</label>
      </div>
      <div class="file-status error file-size-exceeded"
           *ngIf="data.status === uploadStatus.FILE_SIZE_EXCEEDED">
        <label>File size exceeded</label>
      </div>
    </ng-template>
  </ng-container>
</div>
